import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";
import {
  VOID_CONFIRM_MESSAGE,
  VOID_STATUS_FIELD,
} from "../utils/voidTransactionConfig";

export const screen_161_bank_payment_summary: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "162",
    },
    title: "Bank payment",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 8,
            },
            childComponents: [

            ],
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "voucher_no",
            Name: "bank_voucher_summary",
            BindValue: "grid_journal_voucher",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/bank_payment_voucher/<id>",
                },
                ActionType: ActionType.VIEW,
                ScreenId: "162",
                tooltip: "View",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/bank_payment_voucher/<id>",
                },
                ActionType: "Edit",
                ScreenId: "162",
                hiddenWhenVoid: true,
              },
                            {
                ActionType: ActionType.VOID,
                permissionKey: "Void",
                confirmMessage: VOID_CONFIRM_MESSAGE,
                requireVoidReason: true,
                hiddenWhenVoid: true,
                visibleWhenNotDraft: true,
                voidReasonLabel: "Void Reason",
                tooltip: "Void",
                Action: {
                  Module: "bank_payment_voucher",
                  TransactionNoField: "voucher_no",
                },
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "bank_payment_voucher",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "bank_voucher_summary",
              TableName: "vouchers",
              DisplayName: "vouchers",
              Query:
                "SELECT vouchers.id, vouchers.voucher_no, voucher_date, service_job_card.jobcard_no, users.username, SUM(voucher_details.amount) AS amount, vouchers.narration, vouchers.is_void, CASE WHEN COALESCE(vouchers.is_void,0)=1 THEN 'Void' ELSE '' END AS status FROM vouchers LEFT JOIN users ON users.id = vouchers.created_by LEFT JOIN voucher_details ON voucher_details.parent_id = vouchers.id LEFT JOIN ledgers ON ledgers.id = voucher_details.ledger_id LEFT JOIN ledgers l ON l.id = voucher_details.to_ledger LEFT JOIN service_job_card ON service_job_card.parent_id = vouchers.job_card_id WHERE voucher_type = 'BankPayment' GROUP BY vouchers.id, vouchers.voucher_no, voucher_date, users.username, vouchers.narration, service_job_card.jobcard_no, vouchers.is_void",
              // CheckBranch: false,
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                VOID_STATUS_FIELD,
                {
                  IncludeLabel: true,
                  Label: "Voucher No.",
                  BindValue: "txt_voucher_no",
                  Json_Attribute: "voucher_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher date",
                  IsMandatory: false,
                  BindValue: "txt_date",
                  Json_Attribute: "voucher_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Jobcard number",
                  BindValue: "txt_jobcard_no",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Narration",
                  BindValue: "txt_narration",
                  Json_Attribute: "narration",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "txt_amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "username",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

